$(document).ready(function () {

  function updateButtons($container) {
    const $input = $container.find('.product-qty');
    const $minus = $container.find('.product-quantity-toggle.minus');
    const $plus  = $container.find('.product-quantity-toggle.plus');

    let value = parseInt($input.val()) || 1;
    let min   = parseInt($input.attr('min')) || 1;
    let max   = parseInt($input.attr('max')) || 99;

    $minus.prop('disabled', value <= min);
    $plus.prop('disabled', value >= max);
  }

  // init on page load
  $('[class*="product-qty-container"], [class*="line-input"]').each(function () {
    updateButtons($(this));
  });

  // minus / plus click
  $(document).on('click', '.product-quantity-toggle', function () {
    const $btn       = $(this);
    const $container = $btn.closest('[class*="product-qty-container"], [class*="line-input"]');
    const $input     = $container.find('.product-qty');

    let value = parseInt($input.val()) || 1;
    let min   = parseInt($input.attr('min')) || 1;
    let max   = parseInt($input.attr('max')) || 99;

    if ($btn.hasClass('minus') && value > min) {
      $input.val(value - 1);
    }

    if ($btn.hasClass('plus') && value < max) {
      $input.val(value + 1);
    }

    updateButtons($container);
  });

  // manual input
  $(document).on('change', '.product-qty', function () {
    const $input     = $(this);
    const $container = $input.closest('.product-qty-container');

    let value = parseInt($input.val()) || 1;
    let min   = parseInt($input.attr('min')) || 1;
    let max   = parseInt($input.attr('max')) || 99;

    if (value < min) $input.val(min);
    if (value > max) $input.val(max);

    updateButtons($container);
  });

});